<template>
    <div id="main">
        <div>
            <b-carousel id="carousel-1"
                        v-model="slide"
                        :interval="4000"
                        controls
                        indicators
                        background="#ababab"
                        img-width="1920"
                        img-height="710"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart"
                        @sliding-end="onSlideEnd">
                <b-carousel-slide content-visible-up="lg"
                                  v-for="(item) in topNews" :key="item.ID">
                    <template v-slot:img style="height:720px">
                        <img class="d-block img-fluid w-100"
                             width="1920"
                             height="710"
                             :src="$root.baseURL + item.PREVIEW_PICTURE"
                             alt="image slot">
                    </template>
                    <div class="carusel-block mb-1">
                        <h2 class="text-white pt-3 px-1">{{item.NAME}}</h2>
                        <p class="text-left border-top m-auto pt-3" v-html="item.PREVIEW_TEXT"></p>
                        <div style="text-align: left; margin-left: 15px;">
                            <router-link v-if="item.CODE" :to="'/new/' + item.CODE">
                                <base-button type="outline-white" class="btn p-2 my-3">
                                    Подробнее
                                </base-button>
                            </router-link>
                            <router-link v-else :to="'/new/' + item.ID">
                                <base-button type="outline-white" class="btn p-2 my-3">
                                    Подробнее
                                </base-button>
                            </router-link>
                        </div>
                    </div>
                </b-carousel-slide>
                <div class="h-100 d-none d-lg-block"
                     style="background: rgba(20,20,20,0.4); width:40%;
                            position:absolute; top: 0; right: 0;
                            padding-top:150px">
                    <div class="ml-3">
                        <h5 class="mb-3 pt-3" style="color: rgba(255,255,255,0.7)">Новости</h5>
                        <div class="newsRightBanners">
                            <div>
                                <div class="newsRight_item mb-3" style="color: rgba(255,255,255,0.7)"
                                     v-for="(item) in elseNews" :key="item.ID">
                                    {{item.CREATED_DATE}}
                                    <h6>
                                        <router-link v-if="item.CODE" :to="'/new/' + item.CODE" :title="item.NAME">
                                            <span class="text-white mr-2">{{item.NAME}}</span>
                                        </router-link>
                                        <router-link v-else :to="'/new/' + item.ID" :title="item.NAME">
                                            <span class="text-white mr-2">{{item.NAME}}</span>
                                        </router-link>
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div class="w-25">
                            <base-button tag="a" href="/news"
                                         type="default" block>
                                Все новости
                            </base-button>
                        </div>
                    </div>
                </div>
            </b-carousel>
        </div>
        <section class="section bg-secondary d-lg-none" >
            <div class="container">
                <b-tabs content-class="">
                    <b-tab title="Все" active v-on:click="newsTab('all')"></b-tab>
                    <b-tab title="Новости" v-on:click="newsTab('news')" v-if="false"></b-tab>
                    <b-tab title="Мероприятия" v-on:click="newsTab('activity')"  v-if="false"></b-tab>
                    <b-tab title="Вебинары" v-on:click="newsTab('webinar')" v-if="false"></b-tab>
                    <b-tab title="Форумы и конференции" v-on:click="newsTab('forum')" v-if="false"></b-tab>
                    <b-tab title="Нововведения" v-on:click="newsTab('innovations')" v-if="false"></b-tab>
                    <div class="row">
                        <div class="col-md-8">
                            <card gradient="neutral"
                                  no-body
                                  shadow-size="lg"
                                  class="border-0 mt-3"
                                  v-for="(item) in topNews" :key="item.ID">
                                <div class="px-5 py-3">
                                    <div class="row align-items-center height-card">
                                        <div>
                                            <h5 class="text-default">{{item.NAME}}</h5>
                                            <p class="mt-3" v-html="item.PREVIEW_TEXT"></p>
                                            <router-link v-if="item.CODE" :to="'new/' + item.CODE" class="text-default">Подробнее</router-link>
                                            <router-link v-else :to="'new/' + item.ID" class="text-default">Подробнее</router-link>
                                            <base-button type="default"
                                                         class="float-right"
                                                         v-if="item.IBLOCK_SECTION_ID == 12 ||
                                                               item.IBLOCK_SECTION_ID == 13"
                                                         @click="showModal('Записаться', item.NAME)">
                                                Записаться
                                            </base-button>
                                        </div>
                                    </div>
                                </div>
                            </card>
                        </div>
                        <div class="col-md-4 mt-3 bg-gradient-neutral" v-if="false">
                            <h2 class="display-3 text-center mb-3 pt-3">Новости</h2>
                            <div class="newsRight" v-bar>
                                <div>
                                    <div class="newsRight_item mb-3 text-default" v-for="(item) in elseNews" :key="item.ID">
                                        {{item.CREATED_DATE}}
                                        <h6><a href="#" class="text-dark">{{item.NAME}}</a></h6>
                                    </div>
                                </div>
                            </div>
                            <div class="ml-lg-auto">
                                <base-button tag="a" href="/news"
                                             type="default" block>
                                    Все новости
                                </base-button>
                            </div>
                        </div>
                    </div>
                </b-tabs>
            </div>
        </section>
        <section class="section pt-0">
            <div class="container">
                <div class="row justify-content-center pt-5">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-center">Продукты</h2>
                        <div class="row row-grid">
                            <div class="col-lg-4 mt-4 pr-2 pl-2" v-for="item in products" :key="item.ID">
                                <card class="border-0" hover shadow body-classes="py-4">
                                    <h6 class="text-default text-uppercase">{{item.NAME}}</h6>
                                    <img :src="$root.baseURL + item.PREVIEW_PICTURE" width="100%" :alt="item.PREVIEW_TEXT">
                                    <div class="btn-wrapper pt-4 text-center">
                                        <router-link v-if="item.CODE" :to="'/product/' + item.CODE">
                                            <base-button type="outline-default" class="btn-sm p-2">
                                                Подробнее
                                            </base-button>
                                        </router-link>
                                        <router-link v-else :to="'/product/' + item.ID">
                                            <base-button type="outline-default" class="btn-sm p-2">
                                                Подробнее
                                            </base-button>
                                        </router-link>
                                        <base-button type="outline-default"
                                                     class="btn-sm ml-2 p-2"
                                                     @click="showModal('Узнать цену', item.NAME)">
                                            Узнать цену
                                        </base-button>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-wrapper text-center mt-4">
                    <base-button tag="a"
                                 href="/products"
                                 class="mb-3 mb-sm-0 btn-default"
                                 type="info"
                                 icon="fa fa-navicon">
                        Все продукты
                    </base-button>
                </div>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden solutions">
            <div class="shape solutions-backgraund" v-parallax="0.3"></div>
            <div class="container py-0">
                <div class="row align-items-center">
                    <div class="col-md-5 order-lg-2 ml-lg-auto solutions-right d-none">
                        <h2 class="display-3 text-center text-white" style="font-weight:600">Решения</h2>
                        <p class="text-white">Повысить продуктивность благодаря разработке инновационных изделий.</p>
                        <div class="btn-wrapper mt-4">
                            <base-button tag="a"
                                         href="/solutions/"
                                         class="mb-3 mb-sm-0 btn-default"
                                         type="info"
                                         icon="fa fa-navicon">
                                Все решения
                            </base-button>
                        </div>
                    </div>
                    <div class="col-md-5 order-md-2">
                        <div class="pl-2 text-white">

                            <a href="/solutions"><h2 class="display-3 text-white mb-5"><b>Решения и Услуги</b></h2></a>
                            <p>
                                Ваш успех значит для нас все.<br> Вот почему мы разработали набор услуг,
                                который поможет вам достичь ваших бизнес-целей.
                            </p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="default" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <router-link to="/konsaltingovye-uslugi"><h6 class="mb-0 text-white">Поставка комплексных решений</h6></router-link>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="default" circle class="mr-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0 text-white">Выполнение расчётов и НИР на заказ</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="default" circle class="mr-3" icon="fa fa-navicon"></badge>
                                        <router-link to="/solutions">
                                            <h6 class="mb-0 text-white">Полный перечень услуг</h6>
                                        </router-link>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-7 order-lg-1 pr-lg-5">
                        <router-link to="/solution/prochnost">
                            <card shadow class="shadow-lg--hover">
                                <div class="d-flex row">
                                    <div class="col-sm-2 col-12 text-center">
                                        <icon gradient="default" color="white" shadow
                                              rounded><img src="img/icons/strength.svg" width="100%"></icon>
                                    </div>
                                    <div class="col-sm-10 col-12">
                                        <h5 class="title text-default text-center text-sm-left">Прочность</h5>
                                    </div>
                                </div>
                            </card>
                        </router-link>
                        <router-link to="/solution/gidrogazodinamika">
                            <card shadow class="shadow-lg--hover mt-4">
                                <div class="d-flex row">
                                    <div class="col-sm-2 col-12 text-center">
                                        <icon gradient="default" color="white" shadow
                                              rounded><img src="img/icons/ggd.svg" width="100%"></icon>
                                    </div>
                                    <div class="col-sm-10 col-12">
                                        <h5 class="title text-default text-center text-sm-left">Гидрогазодинамика (CFD)</h5>
                                        <p>
                                            
                                        </p>
                                    </div>
                                </div>
                            </card>
                        </router-link>
                        <router-link to="/solution/elektromagnetizm">
                            <card shadow class="shadow-lg--hover mt-4">
                                <div class="d-flex row">
                                    <div class="col-sm-2 col-12 text-center">
                                        <icon gradient="default" color="white" shadow
                                              rounded><img src="img/icons/electro.svg" width="100%"></icon>
                                    </div>
                                    <div class="col-sm-10 col-12">
                                        <h5 class="title text-default text-center text-sm-left">Электромагнитный анализ</h5>
                                        <p>
                                            
                                        </p>
                                    </div>
                                </div>
                            </card>
                        </router-link>
                        <router-link to="/solution/teplovoy-analiz">
                            <card shadow class="shadow-lg--hover mt-4">
                                <div class="d-flex row">
                                    <div class="col-sm-2 col-12 text-center">
                                        <icon gradient="default" color="white" shadow
                                              rounded><i class="fa fa-thermometer-half"></i></icon>
                                    </div>
                                    <div class="col-sm-10 col-12">
                                        <h5 class="title text-default text-center text-sm-left">Тепловой анализ</h5>
                                        <p>
                                            
                                        </p>
                                    </div>
                                </div>
                            </card>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary d-none">
            <div class="container service">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 pr-md-5 order-md-1">
                        <img src="/img/theme/service.jpg" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-2">
                        <div class="pl-md-5 pl-2">
                            <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" type="primary" shadow
                                  rounded></icon>
                            <h3>Решения и Услуги</h3>
                            <p>
                                Ваш успех значит для нас все. Вот почему мы разработали полный набор услуг,
                                основанных на результатах, которые помогут вам достичь ваших бизнес-целей.
                            </p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">Поставка комплексных решений </h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0">Выполнение расчётов и НИР на заказ</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ContactForm></ContactForm>
        <CallModal ref="callModal"></CallModal>
    </div>
</template>
<script>
    import CallModal from "@/components/CallModal.vue";
    import ContactForm from "@/components/ContactForm.vue";
    import carousel from 'vue-owl-carousel';
    export default {
        components: {
            CallModal,
            ContactForm,
            carousel,
        },
        data() {
            return {
                slide: 0,
                sliding: null,
                products: null,
                news: null,
                banners: null,
                reviews: null,
                topNews: [],
                elseNews: []
            }
        },
        methods: {
            onSlideStart(slide) {
                this.sliding = true
            },
            onSlideEnd(slide) {
                this.sliding = false
            },
            showModal(title, name) {
                this.$refs.callModal.modals.sendApply = true;
                this.$refs.callModal.modals.title = title
                this.$refs.callModal.modals.info = name
            },
            async loadInfo() {
                let params = new Map();
                params.set('count', 6);
                params.set('entity', 'products');

                this.products = await this.$root.loadContent(params)

                let params_2 = new Map();
                params_2.set('entity', 'pages');
                params_2.set('code', 'home');

                let seo = await this.$root.loadContent(params_2)
                this.$root.title = seo[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = seo[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            },
            async newsTab(id_tab) {
                let params = new Map();
                params.set('count', 30);
                params.set('entity', 'news');
                if (id_tab != 'all') {
                    params.set('SECTION_CODE', id_tab);
                }

                this.news = await this.$root.loadContent(params);
                this.topNews = this.news.slice(0, 3);
                this.elseNews = this.news.slice(3, 9);
            },
        },
        mounted() {
            this.loadInfo();
            this.$axios
                .get('/rest/banners/')
                .then(response => {
                    this.banners = response.data
                });
            var paramsReviews = {
                params: {
                    count: '10',
                } 
            };
            this.$axios
                .get('/rest/reviews/', paramsReviews)
                .then(response => {
                    this.reviews = response.data
                });
            this.newsTab('all');
        }
    };
</script>
<style>
    .develop div{
        border: 1px solid var(--default);
    }
    .vb > .vb-dragger {
        z-index: 5;
        width: 5px;
        right: 0;
        background: var(--default) !important;
    }
    .btn-default{
        font-family: Montserrat-Bold;
        letter-spacing: 0.1em !important;
    }
    .solutions-backgraund{
        background: url('/img/theme/bg-image-2-1920x1304.jpg') !important;
    }
    .solutions .col-lg-7 a{
        color: #525f7f;
    }
    .service .icon-shape-primary{
        background-color: rgba(0, 147, 183, 0.1);
    }
    .service .badge-primary{
        background-color: rgba(0, 147, 183, 0.1);
    }
    .newsRight {
        height: 400px;
        padding-right:5px;
    }
    .carusel-block span{
        color: white !important;
    }
    .owl-prev, .owl-next {
      position: absolute;
      top: 45%;
      transform: translateY(-50%);
      font-size: 5rem !important;
      color: var(--default) !important;
      background: none !important; 
    }
    .owl-prev:hover, .owl-next:hover{
        background: rgba(233,236,239,0.3) !important;
    }

    .owl-prev {
      left: -3rem;
    }

    .owl-next {
      right: -3rem;
    }
    @media (min-width: 992px) {
        .carusel-block {
            background: rgba(118, 28, 34, 0.5);
            width: 50%;
        }
        .height-card{
            height: 250px;
        }
        .newsRight {
            height: 740px !important;
            padding-right:5px;
        }
        .newsRightBanners{
            height: 400px !important;
        }
        .btn{
            letter-spacing: 0.1em !important;
        }
        .carusel-block p {
            width: 95%;
        }
        .solutions-right{
            
        }
        .solutions-right p{
            margin-left: 30%;
            padding-top: 20px;
        }
        .solutions-right a{
            margin-left: 30%;
            margin-top: 5px;
        }
         #main .section-contact-us{
            margin: 20px auto;
            width: 60%
        }
    }
</style>
